export { default as Mindbox } from './Mindbox'
